import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React, { isValidElement } from 'react';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import '@babel/runtime-corejs3/core-js-stable/instance/fill';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import IcClose from '../icons/IcClose.js';
import ToastWrapper from './ToastWrapper.js';
import { TOAST_ANIMATIONS } from '../../constants/toast.js';
import usePortal from '../../hooks/usePortal.js';
import styles from './ToastAction.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, styles);
function ToastAction(_ref) {
  var imageComponent = _ref.imageComponent,
    children = _ref.children,
    onDestroy = _ref.onDestroy,
    onClose = _ref.onClose,
    duration = _ref.duration,
    bottomPaddingBase = _ref.bottomPaddingBase,
    overTheDimmedLayer = _ref.overTheDimmedLayer;
  var Portal = usePortal();
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(ToastWrapper, {
    isShow: !!children,
    destroy: onDestroy,
    duration: duration,
    animation: TOAST_ANIMATIONS.SLIDE,
    bottomPaddingBase: bottomPaddingBase,
    overTheDimmedLayer: overTheDimmedLayer
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('article')
  }, imageComponent && ( /*#__PURE__*/React.createElement("span", {
    className: cx('area-profile')
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('profile')
  }, imageComponent))), /*#__PURE__*/isValidElement(children) ? ( /*#__PURE__*/React.createElement("p", {
    className: cx('text')
  }, children)) : ( /*#__PURE__*/React.createElement("p", {
    className: cx('text'),
    dangerouslySetInnerHTML: {
      __html: "".concat(children)
    }
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cx('button-close'),
    onClick: onClose
  }, /*#__PURE__*/React.createElement(IcClose, {
    width: 20,
    height: 20,
    fill: "#929294"
  }), /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uB2EB\uAE30")))));
}

export { ToastAction as default };
